// extracted by extract-css-chunks-webpack-plugin
module.exports = {"feedbackTextForm":"OrderHelpFeedbackText-8034ed0cec242246","modal":"OrderHelpFeedbackText-12b22398d87eb9b4","feedbackText":"OrderHelpFeedbackText-60426fdcc4f57683"};